import {css} from "styled-components";

export const AuditTrailStyle = css`
  .audit-table {
    th.ant-table-cell {
      border-top: 1px solid #f0f0f0
    }
  }

  .audit-index-row {
    cursor: pointer;
  }

  .audit-view-row {
    vertical-align: top;
    pointer-events: none;

    /* vertical-align: top; */
  }

  .row-added {
    /* font-weight: 500; */
    background-color: #b7eb8f; /* green */

    /* text-decoration: line-through; */
    /* opacity: 0.7; */
  }

  .row-removed {
    /* text-decoration: line-through; */
    text-decoration: underline !important;
    text-underline-offset: -0.33em; /** so different font sizes will have equal offset instead of line-through */
    background-color: #ffccc7; /* red */
    opacity: 0.7;
    text-decoration-skip-ink: none;

    &.file {
      text-decoration: unset;

      .file-name {
        text-decoration: line-through;
      }
    }
  }

  .row-removed--yellow {
    color: grey;

    /* text-decoration: line-through; */
    text-decoration: underline !important;
    text-underline-offset: -0.33em; /** so different font sizes will have equal offset instead of line-through */
    background-color: #ffe58f; /* yellow */
    opacity: 0.7;
    text-decoration-skip-ink: none;
  }

  .row-removed--red {
    color: grey;

    /* text-decoration: line-through; */
    text-decoration: underline !important;
    text-underline-offset: -0.33em; /** so different font sizes will have equal offset instead of line-through */
    background-color: #ffccc7; /* red */
    opacity: 0.7;
    text-decoration-skip-ink: none;
  }

  .row-changed {
    background-color: #fff1b8 /* gold-2 */
  }


`;
